import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import router from './router';
import { Provider } from 'react-redux'
import store from './redux/store';
import { showNextAlert } from "./redux/reducers/global/alerts/alertSlice";
import { selectCurrentAlert } from './redux/reducers/global/alerts/alertSlice';
import Modal from "react-modal";
import ModalRoot from './components/global/modal/ModalRoot';
import useAuthRequiredListener from './hooks/useAuthRequiredListener';

Modal.setAppElement("#root");

const Root = () => {
  const dispatch = useDispatch();
  const currentAlert = useSelector(selectCurrentAlert);
  useAuthRequiredListener();
  React.useEffect(() => {
    if (!currentAlert) {
      return undefined;
    }
    const duration = Number(currentAlert.duration);
    const timeoutMs = Number.isFinite(duration) && duration > 0 ? duration : 2500;
    const timeoutId = window.setTimeout(() => {
      dispatch(showNextAlert());
    }, timeoutMs);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [currentAlert, dispatch]);

  return (
    <>
      <RouterProvider router={router} />
      {currentAlert ? (
        <div
          className={`global-alert-toast global-alert-toast--${currentAlert.severity || 'info'}`}
          role="status"
          aria-live="polite"
        >
          {currentAlert.message}
        </div>
      ) : null}
    </>
  );
};

// Use createRoot API for React 18
const rootContainer = document.getElementById('root');
ReactDOM.createRoot(rootContainer).render(
  <Provider store={store}>
    <Root />
    <ModalRoot/>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
